import { BonusStage } from 'api/common';
import { MissionId } from '../types';

export const CLOSE_MODAL_ACTION_URL = '#close';

export const MAX_PROGRESS = 100;

export const MISSION_PREFIX = 'wn_';

export const CASH_BONUS_MISSION_IDS = [
  MissionId.WN_4,
  MissionId.WN_17,
  MissionId.WN_19,
];

export const CP_MISSION_IDS = [MissionId.WN_1, MissionId.WN_2];

export const INACTIVE_BONUS_STAGES: BonusStage[] = [
  BonusStage.Finished,
  BonusStage.Expired,
  BonusStage.Canceled,
  BonusStage.Lost,
];
